import { Box, ListItem, Stack, Typography, styled } from '@mui/material';

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  containerType: 'inline-size',
  height: theme.spacing(11.25),
  borderBottom: `1px solid ${theme.palette.grey[800]}`,
  [theme.breakpoints.down('sm')]: {
    height: theme.spacing(10),
    width: '100%',
    padding: theme.spacing(1, 0),
  },
}));

export const Container = styled(Box)({
  display: 'grid',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',

  gridTemplateColumns:
    'minmax(230px, 35%) minmax(40px, 40%) minmax(170px, 25%)',
  [`@container (max-width: 400px)`]: {
    gridTemplateColumns: '60% 20% 20%',
  },
});

export const SongTitleAndArtistNameContainer = styled(Stack)({
  flex: 1,
  marginLeft: 0,
  overflow: 'hidden',
});

export const DurationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginLeft: theme.spacing(1),
  paddingTop: theme.spacing(0.2),
  whiteSpace: 'nowrap',
  flexShrink: 0,
  [`@container (max-width: ${theme.breakpoints.values.md}px)`]: {
    marginRight: theme.spacing(1),
  },
}));

export const SongTitle = styled(Typography)({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const DurationText = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.grey[400],
}));

export const WaveformContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  maxWidth: theme.spacing(50),
  flexShrink: 0,
  paddingTop: theme.spacing(0.8),
  // The width of the waveform is currently set based on developer observations
  // and should be adjusted once we create our own waveform generator
  width: '90%',

  [`@container (max-width: ${theme.breakpoints.values.desktop}px)`]: {
    width: '100%',
  },
  [`@container (max-width: ${theme.breakpoints.values.sm}px)`]: {
    display: 'none',
  },
}));

export const SongActionsContainer = styled(Box)(() => ({
  marginLeft: 'auto',
}));

export const PlayerContainer = styled(Box)(() => ({
  display: 'flex',
  flexShrink: 0,
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const SeekbarContainer = styled(Box)({
  display: 'flex',
  flexShrink: 0,
  justifyContent: 'left',
  alignItems: 'center',
  [`@container (max-width: 600px)`]: {
    margin: 'auto',
  },
});
